import { Button, CircularProgress } from "@material-ui/core";
import { useObserver } from "mobx-react";
import React from "react";
interface ButtonStateProps {
    disabled: boolean,
    loading: boolean,
    onClick: () => void,
    children: React.ReactNode,
}
const ButtonState: React.FC<ButtonStateProps> = (props: ButtonStateProps) => {
    const { disabled, loading, onClick } = props
    return useObserver(() => (
        <>
        <Button
            variant="contained"
            color="primary"
            disabled={disabled}
            onClick={onClick}
        >
            {
                loading ? 
                <CircularProgress size="1.2rem" color="inherit" /> : props.children
            }
        </Button>
        </>
    ));
};

export default ButtonState;